<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>

      <v-col cols="12" sm="6" md="6">
        <v-autocomplete
          v-model="entry.varietyId"
          v-bind="getObject('varietyId')"
          label="Variedade"
          :items="extraData.accountContext.allVarietiesInStorage"          
          item-value="id"
          item-text="title"
          autocomplete="off"
          :disabled="readOnly"          
        >          
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <DateField
          :inputData.sync="entry.date"
          v-bind="getObject('date')"
          label="Data"
          :hasTodayButton="true"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField          
          v-bind="getObject('quantity')"
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade"
          :disabled="readOnly"          
          autocomplete="off"          
        />        
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue";
import gql from 'graphql-tag';
import SubCultureNew from "@models/sub_cultures/new.vue";
import BaseUtil from "@shared_components/base_util.vue";
import DateField from "@shared_components/date_field.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    SubCultureNew: SubCultureNew,   
    BaseUtil: BaseUtil,
    DateField: DateField,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    if (this.entry && this.entry.subCultureId) {
      this.selectSubCulture();
    }
  },
  mounted() {
    // if (this.entry.unitId) {
    //   this.getPackagingsForUnit(false);
    // }
  },
  methods: {
    selectSubCulture: function() {
      if (this.entry.subCultureId) {
        this.entry.subCulture = this.extraData.globalContext.allSubCultures.find(obj => obj.id == this.entry.subCultureId);
      }
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },      
    subCultureCreated: function(subCulture) {
      this.extraData.globalContext.allSubCultures.unshift(subCulture);
      this.entry.subCultureId = subCulture.id;
      this.entry.subCulture = subCulture;
    },
  }
};
</script>

<style scoped></style>
